var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.301 0C16.675 0 19.4261 2.40345 19.4629 5.36868L19.7618 5.36991C23.5281 5.36991 26.5908 8.06392 26.5908 11.3759V17.9952C26.5908 21.306 23.5281 24 19.7618 24H6.82907C3.06408 24 0 21.306 0 17.9952V11.3759C0 8.06392 3.06408 5.36991 6.82907 5.36991L7.10725 5.36883L7.1159 5.13545C7.20153 3.77409 7.83866 2.52521 8.93193 1.57321C10.1019 0.552003 11.6728 0.0420002 13.301 0ZM19.7618 7.16992L19.4631 7.16884L19.4633 9.06725C19.4633 9.56405 19.0051 9.96725 18.4405 9.96725C17.876 9.96725 17.4178 9.56405 17.4178 9.06725L17.4177 7.16884H9.15134L9.15147 9.06725C9.15147 9.56405 8.69329 9.96725 8.12875 9.96725C7.56421 9.96725 7.10602 9.56405 7.10602 9.06725L7.10589 7.16884L6.82907 7.16992C4.19181 7.16992 2.04545 9.05633 2.04545 11.3759V17.9952C2.04545 20.3136 4.19181 22.2 6.82907 22.2H19.7618C22.399 22.2 24.5454 20.3136 24.5454 17.9952V11.3759C24.5454 9.05633 22.399 7.16992 19.7618 7.16992ZM13.2969 1.80001C12.191 1.83361 11.1546 2.16961 10.3719 2.85121C9.60056 3.52411 9.16822 4.41611 9.15192 5.36871L17.4149 5.36883L17.4108 5.21598C17.2853 3.31418 15.4889 1.80001 13.2969 1.80001Z",
    fill: "#09321C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.70b3cab1c7a1014eab32217b9312cf30.svg";
export { ForwardRef as ReactComponent };